import { StarIcon } from "@/components/utils/icons/StarIcon";
import { Colors } from "@/enums/Colors";
import { Box, Typography } from "@mui/material";

interface DataKey {
  name: string;
  color: string;
}

interface Props {
  title: string;
  keys: DataKey[];
  cashBalanceCard?: boolean;
}

export interface AskAIButtonProps {
  onStarIconClick?: () => void;
  disableAskAIButton?: boolean;
  disableExpand?: boolean;
}

export const ChartTopBar = ({ title, keys, onStarIconClick, disableAskAIButton, cashBalanceCard = false }: Props & AskAIButtonProps) => {
  return (
    <Box display="flex" alignItems="center" position="relative" justifyContent="space-between" paddingTop={cashBalanceCard ? "20px" : 0}>
      <Typography fontWeight={600} color={Colors.LIGHT_GRAY_8A8E93} fontSize="0.875rem">
        {title}
      </Typography>
      <Box display="flex" alignItems="center" columnGap="1rem">
        <Box display="flex" columnGap="1rem">
          {keys.map(({ color, name }) => {
            return (
              <Box display="flex" alignItems="center" key={name} columnGap="0.3rem">
                <Box
                  sx={{
                    width: "1rem",
                    height: "1rem",
                    borderRadius: "0.25rem",
                    backgroundColor: color,
                  }}
                />
                <Typography color={Colors.LIGHT_GRAY_656970}>{name}</Typography>
              </Box>
            );
          })}
        </Box>
        {!disableAskAIButton && (
          <Box position={cashBalanceCard ? "absolute" : "relative"} right={0} top={cashBalanceCard ? "-15px" : 0}>
            <StarIcon
              onClick={() => {
                if (onStarIconClick) {
                  onStarIconClick();
                }
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};
